import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { ContentState } from '../../../store/state/content.state';
import { RequestUtil } from '../../../utils/request.util';
import { NewsItem } from '../../../models/news-item.model';
import { NewsService } from '../../../services/news.service';
import { HyphenPipe } from 'src/app/pipes/hyphen.pipe';
import { Title } from '@angular/platform-browser';
import { getSectionFromPath, setTitleComponent } from 'src/app/utils/titles.util';


@Component({
    selector: 'u4-cpp-news-list',
    templateUrl: './news-list.component.html'
})
export class NewsListComponent implements OnInit, OnDestroy {

    public query = '';
    public startDate: string | null = null;
    public endDate: string | null = null;
    public newsItemsList$: Observable<NewsItem[]>;
    public labels: {[key: string]: string};
    public pageNumber: number;
    public pageSize = 30;
    public totalResults = 0;
    public productStorage = 'NewsQuery';
    protected destroy$: Subject<void> = new Subject();
    private DEFAULT_IMG_URL = '../../../../assets/images/unit4-logo-white.svg';

    constructor(
        private newsService: NewsService,
        private location: Location,
        private requestUtil: RequestUtil,
        private router: Router,
        private route: ActivatedRoute,
        private store: Store<ContentState>,
        private titleService: Title
    ) {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => {
            this.labels = labels;
            const news = getSectionFromPath(window.location.pathname, 0);
            this.titleService.setTitle(setTitleComponent(news));
        });
    }

    ngOnInit() {
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => {
            this.labels = labels;
        });

        this.newsService.totalResults.pipe(
            takeUntil(this.destroy$)
        ).subscribe((totalResults: string) => this.totalResults = Number(totalResults));

        this.router.events.pipe(
            filter(e => e instanceof NavigationEnd),
            takeUntil(this.destroy$)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        ).subscribe(this.init.bind(this));

        this.init();
    }

    init() {
        const queryParams = this.route.snapshot.queryParams;
        this.pageNumber = queryParams.page as number || 1;
        this.query = queryParams.query as string || '';
        this.startDate = queryParams.startDate as string | null;
        this.endDate = queryParams.endDate as string | null;
        if (this.query === '')
        {this.getQuery(); }
        this.newsItemsList$ = this.getItems();
        this.save(this.query);
    }

    getItems(): Observable<NewsItem[]> {
        const queryParsed = this.parseQuery(this.query);
        return this.requestUtil.request(
            this.newsService.getGeneralNewsItems(this.pageNumber, this.pageSize, queryParsed, this.startDate, this.endDate)
        ) as Observable<NewsItem[]>;
    }

    getImage(item: { headerImage: { medium: string}}) {
        return item && item.headerImage ? item.headerImage.medium : this.DEFAULT_IMG_URL;
    }

    getLink(newsItem: { title: string; id: string }): string[] {
        const hyphenPipe = new HyphenPipe();
        const hyphenatedNewsItemTitle: string = hyphenPipe.transform(newsItem.title);

        return ['news-item', hyphenatedNewsItemTitle, newsItem.id] as string[];
    }

    trackByFn(index: number, item: NewsItem): any {
        return item.id;
    }

    goToPage(pageNumber): void {
        const queryParams = {
            page: pageNumber as number,
            query: this.query,
            startDate: this.startDate,
            endDate: this.endDate
        };

        this.pageNumber = pageNumber as number;
        this.router.navigate(['news'], { queryParams }).catch(() => {});
    }

    public onSearch($event: {[key: string]: string}): void {
        this.pageNumber = 1;
        this.query = $event.query;
        if (this.getSessionStorage() && $event.query === '')
        {sessionStorage.removeItem(this.productStorage); }
        // this.save(query);
        this.goToPage(this.pageNumber);
    }

    public onDateFilter(dates: {[key: string]: string}) {
        document.body.click();
        this.pageNumber = 1;
        this.startDate = dates.start;
        this.endDate = dates.end;
        this.goToPage(this.pageNumber);
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    
    save(query: string): void{
        this.newsItemsList$.subscribe(obj => {
            if (query !== '') {
                if (obj.length !== 0)
                {sessionStorage.setItem(this.productStorage, query); }
                else {
                    sessionStorage.removeItem(this.productStorage);
                }
            }
        });
    }
    
    getQuery(){
        if (this.productStorage in sessionStorage)
        {this.query = sessionStorage.getItem(this.productStorage); }
    }
    
    getSessionStorage(): boolean {
        if (this.productStorage in sessionStorage)
        {return true; }
        return false;
    }
    
    private parseQuery(query: string): string {  
        if (query != null && query !== '') {
            query = (query);
        }
        return query;   
    }
}
